module.exports = __webpack_public_path__ + "img/vital.751bf8dc.png";